<template>
  <b-row>
    <b-col
      v-show="!isLoading"
      v-for="pccItem in pcc"
      :key="pccItem.id"
      cols="12"
      sm="6"
      md="4"
      lg="3"
    >
      <router-link :to="{ name: 'detail-pcc', params: { id: pccItem.id } }">
        <b-card
          :img-src="getBannerImage(pccItem)"
          img-height=""
          img-width="auto"
          no-body
          :style="{
            filter:
              !pccItem.is_open || isPCCEnded(pccItem.end_datetime)
                ? 'grayscale(100%)'
                : '',
          }"
          class="card-developer-meetup img-fluid"
        >
          <b-card-body class="p-1">
            <div class="d-flex mb-1">
              <b-badge
                variant="light-primary"
                pill
                v-for="category in pccItem.pcc_categies"
                :key="category.id"
              >
                {{ category.name }}
              </b-badge>
            </div>
            <!-- header -->
            <div class="meetup-header d-flex align-items-center" style="height:7.7vh;">
              <div class="meetup-day">
                <h6 class="mb-0 text-uppercase">
                  {{ $moment(pccItem.start_datetime).format('ddd') }}
                </h6>
                <h3 class="mb-0">
                  {{ $moment(pccItem.start_datetime).format('Do') }}
                </h3>
              </div>
              <div class="my-auto">
                <b-card-title class="mb-25">
                  {{ pccItem.title | truncate(50)}}
                </b-card-title>
              </div>
            </div>
            <!-- end header -->
            <!-- speaker -->
            <b-media no-body>
              <b-media-aside class="mr-1">
                <b-avatar rounded variant="light-primary" size="34">
                  <feather-icon icon="MicIcon" size="18" />
                </b-avatar>
              </b-media-aside>
              <b-media-body>
                <h6 class="mb-0">
                  {{ pccItem.speakers[0].speaker }}
                </h6>
                <small>{{ pccItem.speakers[0].position }}</small>
              </b-media-body>
            </b-media>
            <!-- end speaker -->
            <!-- date -->
            <b-media no-body>
              <b-media-aside class="mr-1">
                <b-avatar rounded variant="light-primary" size="34">
                  <feather-icon icon="CalendarIcon" size="18" />
                </b-avatar>
              </b-media-aside>
              <b-media-body>
                <h6 class="mb-0">
                  {{
                    $moment(pccItem.start_datetime).format('ddd, Do MMMM YYYY')
                  }}
                </h6>
                <small>
                  {{
                    `${$moment(pccItem.start_datetime).format(
                      'H:mm'
                    )} to ${$moment(pccItem.end_datetime).format('H:mm')} ${
                      isPCCEnded(pccItem.end_datetime) ? 'ENDED' : ''
                    }`
                  }}
                </small>
              </b-media-body>
            </b-media>
            <!-- end date -->
            <!-- address -->
            <b-media no-body style="height:7.5vh">
              <b-media-aside class="mr-1">
                <b-avatar rounded variant="light-primary" size="34">
                  <feather-icon icon="MapPinIcon" size="18" />
                </b-avatar>
              </b-media-aside>
              <b-media-body style="word-break: break-word;" v-html="truncates(pccItem.address,50)">
              </b-media-body>
            </b-media>
            <!-- end address -->
          </b-card-body>
        </b-card>
      </router-link>
    </b-col>
    <b-col
      v-show="isLoading"
      v-for="i in 8"
      :key="i"
    >
      <PCCCardSkeleton />
    </b-col>
    <b-col
      cols="12"
      v-if="pagination.total > pcc.length"
      class="d-flex justify-content-center"
    >
      <b-pagination
        v-model="currentPage"
        :total-rows="pagination.total"
        :per-page="perPage"
        first-number
        last-number
        class="mb-0 mt-1 mt-sm-0"
        prev-class="prev-item"
        next-class="next-item"
        @input="changePage"
      >
        <template #prev-text>
          <feather-icon icon="ChevronLeftIcon" size="18" />
        </template>
        <template #next-text>
          <feather-icon icon="ChevronRightIcon" size="18" />
        </template>
      </b-pagination>
    </b-col>
  </b-row>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardText,
  BCardTitle,
  BCardBody,
  BBadge,
  BImg,
  BMedia,
  BMediaAside,
  BAvatar,
  BMediaBody,
  BPagination,
} from 'bootstrap-vue'
import PCCCardSkeleton from '@/views/user/pcc/components/PCCSkeletonCard.vue'
export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardText,
    BCardTitle,
    BBadge,
    BCardBody,

    BImg,
    BMedia,
    BMediaAside,
    BAvatar,
    BMediaBody,
    BPagination,

    PCCCardSkeleton
  },

  data() {
    return {
      bannerImg: require('@/assets/images/product_banner.png'),
      perPage: 7,
      currentPage: 1,
      pcc: [],
      pagination: {
        from: 1,
        to: 10,
        total: 0,
      },
      isLoading: false
    }
  },

  filters: {
    truncate: function(value, length, start = 0) {
      if (!value) return ''
      value = value.toString()
      if (value.length > length) {
        if (start > 0) {
          return value.substring(start, length + start) + '...'
        } else {
          return value.substring(start, length) + '...'
        }
      } else {
        return value
      }
    },
  },

  mounted() {
    this.fetchPCC()
  },

  watch: {
    perPage() {
      this.fetchPCC()
    },
    currentPage() {
      this.fetchPCC()
    },
  },

  methods: {
    truncates: function(value, length, start = 0) {
      if (!value) return ''
      value = value.toString()
      if (value.length > length) {
        if (start > 0) {
          return value.substring(start, length + start) + '...'
        } else {
          return value.substring(start, length) + '...'
        }
      } else {
        return value
      }
    },
    fetchPCC() {
      this.isLoading = true
      this.$http
        .get('/pcc', {
          params: {
            page: this.currentPage,
            perPage: this.perPage,
            product: this.$route.params.product,
          },
        })
        .then(({ data }) => {
          this.currentPage = data.current_page
          this.pagination.total = data.total
          this.pagination.from = data.from
          this.pagination.to = data.to
          this.pcc = data.data
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    getBannerImage(pccItem) {
      if (pccItem.banner_image_url) {
        return pccItem.banner_image_url
      } else {
        return this.bannerImg
      }
    },
    changePage(page) {
      this.currentPage = page
    },
    isPCCEnded(end_date) {
      return this.$moment().isAfter(this.$moment(end_date))
    },
  },
}
</script>

<style scoped>
.card-img {
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
  object-fit: contain;
  height: 160px;
  width:100%;
}

.card-title {
  font-size: 1.185rem !important;
}
</style>
